package hk.com.vr360_demo2.webapp

import cc.easyandroid.easycompose.component.router.stack.ChildStack
import hk.com.vr360_demo2.webapp.component.AppComponent
import hk.com.vr360_demo2.webapp.component.editor_rewrite.EditorRewriteScreen
import hk.com.vr360_demo2.webapp.component.home.HomeScreen
import hk.com.vr360_demo2.webapp.component.previewer.PreviewerScreen
import hk.com.vr360_demo2.webapp.component.verification.VerificationScreen
import hk.com.vr360_demo2.webapp.component.viewer.ViewerScreen
import js.coroutines.awaitCancellation
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.useEffect
import react.useLayoutEffect
import react.useState
external interface AppProps : Props {
    var appComponent: AppComponent
}
val App = FC<AppProps> { props ->
    val (childStack, setChildStack) = useState(props.appComponent.stack.value)
    useEffect {
        val observer = { newValue: ChildStack<*, AppComponent.Child> ->
            setChildStack(newValue)
        }
        val cancellation = props.appComponent.stack.subscribe(observer)
        awaitCancellation(cancellation::cancel)
    }
    val activeChild = childStack.active
    return@FC div {
        when (val instance = activeChild.instance) {
            is AppComponent.Child.EditorRewriteChild -> EditorRewriteScreen { this.component = instance.component }
            is AppComponent.Child.HomeChild -> HomeScreen { this.component = instance.component }
            is AppComponent.Child.PreviewerChild -> PreviewerScreen { this.component = instance.component }
            is AppComponent.Child.ViewerChild -> ViewerScreen { this.component = instance.component }
            is AppComponent.Child.VerificationChild -> VerificationScreen { this.component = instance.component }
        }
    }
}
